/**
 * Detail Addon Template.
 */
import Addon from '@shared/classes/addon';
import AddonContext from '@shared/components/utils/context/addonContext';
import Channel from '@shared/classes/channel';
import DetailAddonBackground from '../atoms/images/detailAddonBackground';
import DetailAddonChannels from '../sections/addons/detailAddonChannels';
import DetailAddonInfo from '../sections/addons/detailAddonInfo';
import DetailAddonInfoMask from '../atoms/mask/detailAddonInfoMask';
import DetailAddonLogo from '../atoms/images/detailAddonLogo';
import TEmpty from './empty';
import TranslationManager from '@shared/assets/locale/translationsManager';
import useBackKeyboard from '@shared/components/utils/hooks/useBackKeyboard';

/**
 * Displays the detail addon template with the addon and channels.
 */
export default function DetailAddonTemplate({
  asset,
  channels,
  error,
}: {
  asset: Addon;
  channels: Channel[] | null;
  error: boolean | undefined;
}) {
  useBackKeyboard();
  const displayContent = error !== undefined && !error;
  const showError = error !== undefined && !displayContent;
  return displayContent ? (
    <AddonContext.Provider value={{ addon: asset, channels: channels }}>
      <DetailAddonBackground src={asset?.background} />
      <DetailAddonLogo src={asset?.logoColor} />
      <DetailAddonInfoMask />
      <DetailAddonChannels />
      <DetailAddonInfo />
    </AddonContext.Provider>
  ) : showError ? (
    <TEmpty message={TranslationManager.get('PAGES.ADDON.ERROR')} />
  ) : null;
}
